import { shape, string } from 'prop-types'

/**
 * @typedef {Object} CoolingDevice
 * @property {string} coolingDeviceId
 * @property {string} externalId
 * @property {string} [apiConnectionId]
 */

export const coolingDevicePropType = shape({
    coolingDeviceId: string.isRequired,
    externalId: string.isRequired,
    apiConnectionId: string
})
